@import (reference) '../../../../constants/spacing.module.less';

.modal {
  color: var(--default--modal--text-color--1);
}

.modal-body {
  padding: @space-16;
}
